
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqLe1_45IJm5HhQ2d8yyMcU8_4Jwv_45fyPIVLpwqaTgPBxk4Meta } from "/codebuild/output/src3960545583/src/src/pages/faq.vue?macro=true";
import { default as menuFG9s04UjbwXDSOLJ3VmnHbU4r7NsYVY1FNFzlVXjPXcMeta } from "/codebuild/output/src3960545583/src/src/pages/menu.vue?macro=true";
import { default as index5XnRPg_45X5tQzQvO37qB0ZZRrpFmhNpYhMJw2CZPMcpQMeta } from "/codebuild/output/src3960545583/src/src/pages/index.vue?macro=true";
import { default as contactjBUcMBLomv_66RDuPCV9IzWaxUQDCjklZRsXBHspy3MMeta } from "/codebuild/output/src3960545583/src/src/pages/contact.vue?macro=true";
import { default as tutorialESwu7zLu288Oeil_45qXUMdNr4BqSBWz7II_45IY4ofboRcMeta } from "/codebuild/output/src3960545583/src/src/pages/tutorial.vue?macro=true";
import { default as agreementuOUuLWQm1ald3CKZzDjJsn1nZ5mAZe6kXkbIDIDZcWMMeta } from "/codebuild/output/src3960545583/src/src/pages/agreement.vue?macro=true";
import { default as about_45passUjX983xs8vHEx1LKdIaGmLAPYsNr_45yrZhOusTnK29FoMeta } from "/codebuild/output/src3960545583/src/src/pages/about-pass.vue?macro=true";
import { default as indexGyrUC9TS_hTLzLX5VKhzGaZ0xqnVaDjH1L3H40tCON4Meta } from "/codebuild/output/src3960545583/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93Qebs1W5af_xJE8LmuRlijObEYil101NUYRCGLBOIVT8Meta } from "/codebuild/output/src3960545583/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceRgz1QhtqxEpVzGBF9eM6Ia60_450hnwxeNke4q4CBXkPsMeta } from "/codebuild/output/src3960545583/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_939DLDDoaI5lXfQqhBHDqdRbrhppBqh8kPfV6S_45G0twCcMeta } from "/codebuild/output/src3960545583/src/src/pages/notice/[id].vue?macro=true";
import { default as indexS13oosL7Vd5km73EKDb7IBnd8bYRsEA6iq_45X2N8oXYgMeta } from "/codebuild/output/src3960545583/src/src/pages/coupon/index.vue?macro=true";
import { default as indexEsy6noQDuUrfK_45G_UnucCXprem3taJeudNkWp6foCNcMeta } from "/codebuild/output/src3960545583/src/src/pages/mypage/index.vue?macro=true";
import { default as indexFPB8NZGjyGeBo122Xtn_w_45L_VemDX_mAH1BA1IY_45qZsMeta } from "/codebuild/output/src3960545583/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93pLiFnbsQTpO83YrE05l2hQRc8rRyBef19dyNSDpN3dMMeta } from "/codebuild/output/src3960545583/src/src/pages/parking/[id].vue?macro=true";
import { default as index1NPW8a6dTUyZRvRSqRDiIUk1N8cufX1CBL5z5ljJWbIMeta } from "/codebuild/output/src3960545583/src/src/pages/history/index.vue?macro=true";
import { default as indexRbd8sgEEe_qL3N8K_453VvN__zu2yvWObYoNVXNG0arLUMeta } from "/codebuild/output/src3960545583/src/src/pages/monthly/index.vue?macro=true";
import { default as indexXQu3wnfkfW2oDq6Kyt1sOeiJYpT_iSsh_45et0cByCJogMeta } from "/codebuild/output/src3960545583/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexwlw9AZJ7ZYXTfXjfgic_45OiV5UtWFV7KpioD_45QuAMPwEMeta } from "/codebuild/output/src3960545583/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviSBM5Dcg409xqKodBzQUuw9gGxYOPmB3cCxrLv2yRJlYMeta } from "/codebuild/output/src3960545583/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editUwJaOfRGyZvYZynTCon5LL5kw_Z7b2GbKmuRNqL4zH8Meta } from "/codebuild/output/src3960545583/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement7wcnLdDMCkqvcszJ7_45nmogu7UHtS_45foBnSO0tQhfkD4Meta } from "/codebuild/output/src3960545583/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexrou4F01MXeDoOvd7NjDYFmcYn153hqVb8GSQdXBZaFEMeta } from "/codebuild/output/src3960545583/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dG4XXh8PpHQSvotStXpYyIAOZWejiGBu5kH_0p0Zq36cMeta } from "/codebuild/output/src3960545583/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmvUTNEM4eKFOmz_d8wX2fOpArz2qEn83l6Hm24yPCEdMMeta } from "/codebuild/output/src3960545583/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexoYhhY0FTeEXXSyiGPiPdYswA3MgcU2y3pEHkIkpDXzgMeta } from "/codebuild/output/src3960545583/src/src/pages/card/create/index.vue?macro=true";
import { default as indexdD_68Tl093iSsVkO96JE4hZdZYdRMgrFlGBT7jT0pVcMeta } from "/codebuild/output/src3960545583/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm5vrCpiBVDA7T5XohTu2drOT3aEvAgT993S89nVWY7yYMeta } from "/codebuild/output/src3960545583/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmI41I5wYEvFPJo4LcQo0h2iSpmmOfGGSyC2gqXHMdsCMMeta } from "/codebuild/output/src3960545583/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete9dqkx3rntDJWDH_fp47I1I7vFG3SxjbNNmfIhVlmJe0Meta } from "/codebuild/output/src3960545583/src/src/pages/membership/complete.vue?macro=true";
import { default as register9EE0PsJ0HgXi4NNdAFBxACPbHkGSv4kPcuBeRAMzhRwMeta } from "/codebuild/output/src3960545583/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93N6X6tPaNxBeB2IKqoodO4rmnCrWMf8m9zCG2edrdygsMeta } from "/codebuild/output/src3960545583/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmJzAjgUMzpJtlExp0DA3LDICRZwHhHyIXl_45NkNUidFWUMeta } from "/codebuild/output/src3960545583/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93LHNO9p_XlElDB2suZyT2Ayhx7Tmjyd2CHUmEjKRbr5cMeta } from "/codebuild/output/src3960545583/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexzItBuWuKmBaoXsooIIZP1Z74tutjka7iHljwcg9ifNgMeta } from "/codebuild/output/src3960545583/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeEtsPCIGt1Z6vph7Om78NcAZcnXhLoYkx_eVETB5QcnMMeta } from "/codebuild/output/src3960545583/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code0Lp17bo57xrXqaM1Ece6Ag6RD_455uz5WDGcjlB8vlzewMeta } from "/codebuild/output/src3960545583/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completewtaMy_45Usgpudl3mVAEWlmV6D_0fsj_SWewiiP99sMpAMeta } from "/codebuild/output/src3960545583/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerb45AqU5J9XyUxRFZPpKsS10JwlGb23jWfiXQzjkkVPsMeta } from "/codebuild/output/src3960545583/src/src/pages/contact-form/register.vue?macro=true";
import { default as completem1qsf3LDcRTrtUn5hSyXe6LldJ8g4OKo9_8UZE2EtSoMeta } from "/codebuild/output/src3960545583/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexhWOKoCacNILMOINP2eX8GKrWVjmULpMN4EJGpEYvqr0Meta } from "/codebuild/output/src3960545583/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmCdY5rhLF3lyUsBgxg1KR_OTa14Ck3LMH2I6eFDwcrpMMeta } from "/codebuild/output/src3960545583/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completegddTdukgVechsXY6Przw65KBAgIjc6Ryr1WhnGr6mQYMeta } from "/codebuild/output/src3960545583/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexP_A60Hv4VA_IsTiF6ZBlJp57gl9jVR0MSnzRvYUlJykMeta } from "/codebuild/output/src3960545583/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93dDs3xvpJTF8ZWUaDZWL3FpzQGiJCy7SewBP7VwiBEJ4Meta } from "/codebuild/output/src3960545583/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete7dbn0TEgEP2N3hljPWR_19VcSHla7zqquecxEKaksWoMeta } from "/codebuild/output/src3960545583/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasKXatCPBcx5b8wveMj3tIP60O39bF0bMkBZwYegacp90Meta } from "/codebuild/output/src3960545583/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleAOmB7_VMKh2kftuDhedrycPQN2SGnWoGagmZ3E0B3qIMeta } from "/codebuild/output/src3960545583/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailuNc_CKu21xDpAW4Cw0Smd91L_L6ORKpD0YHtPxyjPvoMeta } from "/codebuild/output/src3960545583/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmrEP4ahlDE_NS21uW6DHD2x7SvMz5FqXN4Ces8mvLMb0Meta } from "/codebuild/output/src3960545583/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consenttLvhRMExew5svhphfsCWSM3cL28YCYQ_4557ewQ1eBt_45IMeta } from "/codebuild/output/src3960545583/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmq3hgVzfwpFQxpvqE7ciKSgXO2yrJSZe_452CzjcrSiD1kMeta } from "/codebuild/output/src3960545583/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatee2ayFzyAQ1dXznnvZRJYYOEQOH4XbqrzArRaEhr_ik4Meta } from "/codebuild/output/src3960545583/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completepUEJIaMVJz3wQT7Xymas_AQnq3o_adRIRWnqqJ0cDCEMeta } from "/codebuild/output/src3960545583/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codecTq5ah_45wqAoh5lCpop8s9pLfDKGnnLOl9YNn6OOObCgMeta } from "/codebuild/output/src3960545583/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordz2RAPAlRsvu43hwzxMx_LFRpbFBpM3pRrCkhP_45TsAnYMeta } from "/codebuild/output/src3960545583/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasCed4DA9809VFr3XESKhJiO_2MAyULpeXMlsLBuGSbLAMeta } from "/codebuild/output/src3960545583/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerjvQv4qM1lSIi_jielDq1Y3B7YuRXWUEBPANo8aFvO08Meta } from "/codebuild/output/src3960545583/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeFzaW6k2Xag_v_ge2U_yP8BxzWPkY92H7pR4UQJxPbw4Meta } from "/codebuild/output/src3960545583/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexEXf8ef7lFxshKkTDPc_45bfR4O98JtEGJBZO4G_457cCZJAMeta } from "/codebuild/output/src3960545583/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexFa29G9z0h8Xt97EPw1aXQpoiMpzHQf6_ZlmWKqtzSTMMeta } from "/codebuild/output/src3960545583/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexEUPdYQxilWr86a8ddsG9K_u2JfuwSDkBBmEMDBGyzIIMeta } from "/codebuild/output/src3960545583/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexnXZhmFsHrpbBC_45nD75897tAjaV7n_t4h6D0zR0A1_45EAMeta } from "/codebuild/output/src3960545583/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateSoYbc9TAZel0VgyJw2qh5he8XQtrPk4SV9d8nMhRJmYMeta } from "/codebuild/output/src3960545583/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeDaZXYAP_fZgC8q_45ocXyiqUXS_rRk4lNFVKxgx124LT0Meta } from "/codebuild/output/src3960545583/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmidSIeXQypp5_45jQsFWLzABWMFkVDCsmK_tzQhkJtkLXQMeta } from "/codebuild/output/src3960545583/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexC9TRhtFOVpp5ih1BxzEsxS2LaQdhRuztGud0ZlfPCd8Meta } from "/codebuild/output/src3960545583/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeekwr2ny2zUBpBsc7pyxL4_45bX4ftt0hFRLTI0zBW_LEIMeta } from "/codebuild/output/src3960545583/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatebKyPY5ImSjrOIJlM6DEqBYSBO7gsUFmN0zAZ1KRI9zIMeta } from "/codebuild/output/src3960545583/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexbhGVUmF7sfzEMl9nOZc_458L7sVb1wsfsEytQ_VKSmdEMMeta } from "/codebuild/output/src3960545583/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexskuVltKeF4Qf8LcMVtCmbrZ_45lmPmIC1DPvsPSjdbVUUMeta } from "/codebuild/output/src3960545583/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeEBdrsk0g8uRDLAG_8t3lw2YKNNaYKbzAYxAmsV7C_45n8Meta } from "/codebuild/output/src3960545583/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexfxiYV4rkaF13aLcIdFWuHiQXkvwsLUy8s5aqqelZErUMeta } from "/codebuild/output/src3960545583/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeiAb6yCT_beEy_TbmYaVeJPA9K_45tmFHC7lbW_45cDtXqiIMeta } from "/codebuild/output/src3960545583/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexl6U4IiTY_452Dc96Rk4pAXX4WbrRfGoVYBtBGjEdfUDeUMeta } from "/codebuild/output/src3960545583/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexc_cGJccaI3id5n4ijMMyiSFgd_454DRhhFYTvdl6HgNTAMeta } from "/codebuild/output/src3960545583/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexLZK_45yZfLsqRG1i0Mf1JWxO1KQl91hPoaQMLmCaZ5pyoMeta } from "/codebuild/output/src3960545583/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateEd6chH_S2sAAWX1933wWgh6F4ON6MpV8qA7NcokVe9cMeta } from "/codebuild/output/src3960545583/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmomU9AkWqITr8T55A4oAqi4YI4CN3CZrTK8RxWW1y7RQMeta } from "/codebuild/output/src3960545583/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuFG9s04UjbwXDSOLJ3VmnHbU4r7NsYVY1FNFzlVXjPXcMeta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index5XnRPg_45X5tQzQvO37qB0ZZRrpFmhNpYhMJw2CZPMcpQMeta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexS13oosL7Vd5km73EKDb7IBnd8bYRsEA6iq_45X2N8oXYgMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3960545583/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index1NPW8a6dTUyZRvRSqRDiIUk1N8cufX1CBL5z5ljJWbIMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3960545583/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexXQu3wnfkfW2oDq6Kyt1sOeiJYpT_iSsh_45et0cByCJogMeta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexwlw9AZJ7ZYXTfXjfgic_45OiV5UtWFV7KpioD_45QuAMPwEMeta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexoYhhY0FTeEXXSyiGPiPdYswA3MgcU2y3pEHkIkpDXzgMeta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm5vrCpiBVDA7T5XohTu2drOT3aEvAgT993S89nVWY7yYMeta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmI41I5wYEvFPJo4LcQo0h2iSpmmOfGGSyC2gqXHMdsCMMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3960545583/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete9dqkx3rntDJWDH_fp47I1I7vFG3SxjbNNmfIhVlmJe0Meta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: register9EE0PsJ0HgXi4NNdAFBxACPbHkGSv4kPcuBeRAMzhRwMeta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmJzAjgUMzpJtlExp0DA3LDICRZwHhHyIXl_45NkNUidFWUMeta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeEtsPCIGt1Z6vph7Om78NcAZcnXhLoYkx_eVETB5QcnMMeta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code0Lp17bo57xrXqaM1Ece6Ag6RD_455uz5WDGcjlB8vlzewMeta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completewtaMy_45Usgpudl3mVAEWlmV6D_0fsj_SWewiiP99sMpAMeta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerb45AqU5J9XyUxRFZPpKsS10JwlGb23jWfiXQzjkkVPsMeta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmCdY5rhLF3lyUsBgxg1KR_OTa14Ck3LMH2I6eFDwcrpMMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completegddTdukgVechsXY6Przw65KBAgIjc6Ryr1WhnGr6mQYMeta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexP_A60Hv4VA_IsTiF6ZBlJp57gl9jVR0MSnzRvYUlJykMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete7dbn0TEgEP2N3hljPWR_19VcSHla7zqquecxEKaksWoMeta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleAOmB7_VMKh2kftuDhedrycPQN2SGnWoGagmZ3E0B3qIMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailuNc_CKu21xDpAW4Cw0Smd91L_L6ORKpD0YHtPxyjPvoMeta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmrEP4ahlDE_NS21uW6DHD2x7SvMz5FqXN4Ces8mvLMb0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consenttLvhRMExew5svhphfsCWSM3cL28YCYQ_4557ewQ1eBt_45IMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmq3hgVzfwpFQxpvqE7ciKSgXO2yrJSZe_452CzjcrSiD1kMeta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completepUEJIaMVJz3wQT7Xymas_AQnq3o_adRIRWnqqJ0cDCEMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codecTq5ah_45wqAoh5lCpop8s9pLfDKGnnLOl9YNn6OOObCgMeta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordz2RAPAlRsvu43hwzxMx_LFRpbFBpM3pRrCkhP_45TsAnYMeta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerjvQv4qM1lSIi_jielDq1Y3B7YuRXWUEBPANo8aFvO08Meta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeFzaW6k2Xag_v_ge2U_yP8BxzWPkY92H7pR4UQJxPbw4Meta || {},
    component: () => import("/codebuild/output/src3960545583/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3960545583/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]